import {
  client,
  type UserCredentials,
  unwrapApiResponse,
} from "@cryptors/api-client";

export const postLogin = async (credentials: UserCredentials) => {
  return unwrapApiResponse(
    client.post<{ 201: { accessToken: string } }, unknown, true>({
      body: credentials,
      throwOnError: true,
      url: "/auth/login",
    }),
  );
};
